// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"2572c387","223":"4e626532"}[chunkId] + ".chunk.js";
};